import React, { useEffect, useState } from 'react';
import { postsApi } from '../services/api';
import { Link } from 'react-router-dom';
import LoadingOverlay from '../components/LoadingOverlay';

export default function PostsPage() {
  const [posts, setPosts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    postsApi.list().then(r => setPosts(r.data.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const statusLabel = (s: string) => {
    if (s === 'published') return 'Pubblicato';
    if (s === 'publishing') return 'In pubblicazione';
    if (s === 'failed') return 'Fallito';
    return s;
  };

  const statusIcon = (s: string) => {
    if (s === 'published') return 'check_circle';
    if (s === 'publishing') return 'sync';
    return 'error';
  };

  return (
    <div className="page">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1>I miei post</h1>
        <Link to="/create-post" style={{
          display: 'flex', alignItems: 'center', gap: 5,
          padding: '7px 12px', background: 'var(--primary-sub)',
          borderRadius: 20, fontSize: 13, fontWeight: 600,
          color: 'var(--primary)', textDecoration: 'none',
        }}>
          <span className="mi mi-18">add</span> Nuovo
        </Link>
      </div>

      {loading && <LoadingOverlay title="Caricamento dei post..." subtitle="Un momento" icon="grid_on" />}

      {!loading && posts.length === 0 && (
        <div style={{ textAlign: 'center', padding: '48px 20px' }}>
          <span className="mi" style={{ fontSize: 48, color: 'var(--text-3)', display: 'block', marginBottom: 12 }}>grid_on</span>
          <p style={{ fontSize: 15, fontWeight: 600, color: 'var(--text-2)', marginBottom: 6 }}>Nessun post ancora</p>
          <p style={{ fontSize: 13, color: 'var(--text-3)', marginBottom: 20 }}>Pubblica il tuo primo contenuto</p>
          <Link to="/create-post" className="btn btn-primary" style={{ display: 'inline-flex', width: 'auto', padding: '12px 24px' }}>
            <span className="mi mi-18">add</span> Pubblica ora
          </Link>
        </div>
      )}

      {posts.map((p: any) => (
        <div key={p.id} className="post-card">
          {p.media_url && p.media_type !== 'video' && (
            <img src={p.media_url} alt="" className="post-thumb" />
          )}
          {p.media_url && p.media_type === 'video' && (
            <div className="post-thumb post-thumb-video">
              <span className="mi" style={{ fontSize: 36, color: 'var(--text-3)' }}>play_circle_filled</span>
            </div>
          )}
          <div className="post-body">
            <div className="post-meta">
              <span className={`post-status ${p.status}`}>
                <span className="mi mi-16">{statusIcon(p.status)}</span>
                {statusLabel(p.status)}
              </span>
              <span className="post-date">
                {new Date(p.created_at).toLocaleDateString('it-IT', { day: 'numeric', month: 'short' })}
              </span>
            </div>
            <p className="post-caption">
              {p.caption?.substring(0, 120)}{(p.caption?.length ?? 0) > 120 ? '…' : ''}
            </p>
            {(p.publish_facebook || p.facebook_post_id || p.publish_instagram || p.instagram_post_id) && (
              <div className="plat-badges">
                {(p.publish_facebook || p.facebook_post_id) && (
                  <span className="plat-badge plat-fb">Facebook</span>
                )}
                {(p.publish_instagram || p.instagram_post_id) && (
                  <span className="plat-badge plat-ig">Instagram</span>
                )}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
